/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import {
	HcpSummaryFragmentDoc,
	HcpAffiliationLinkFragmentDoc
} from '../../../../core/fragments/Hcp/HCP.hook';
import { HcoSummaryFragmentDoc } from '../../../../core/fragments/Hco/HCOSummary.hook';
import { NotFoundErrorFragmentDoc } from '../../../../core/fragments/core.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateRecentProfilesMutationVariables = Types.Exact<{
	veevaId: Types.Scalars['ID']['input'];
}>;

export type UpdateRecentProfilesMutation = {
	__typename?: 'Mutation';
	updateRecentProfiles:
		| {
				__typename?: 'ProfileVisit';
				lastVisit: any;
				profile:
					| {
							__typename?: 'HCO';
							vid_V: string;
							veevaid_V: string;
							statusCda_V?: string | null;
							statusCda_VId?: string | null;
							hcoNameCda_V?: string | null;
							hcoNameShort_V?: string | null;
							hcoNameEnglish_V?: string | null;
							hcoNameIntl_V?: string | null;
							hcoTypeCda_V?: string | null;
							addresses: Array<{
								__typename?: 'Address';
								vid_V: string;
								primaryCda_V?: boolean | null;
								cityCda_V?: string | null;
								cityIntl_V?: string | null;
								stateCda_V?: string | null;
								countryCda_V?: string | null;
								streetAddress1Cda_V?: string | null;
								streetAddress1Intl_V?: string | null;
								postalCodeCda_V?: string | null;
								postalCodeIntl_V?: string | null;
							}>;
							hcoType?: {
								__typename?: 'HCOType';
								id: string;
								name: string;
							} | null;
					  }
					| {
							__typename?: 'HCP';
							vid_V: string;
							veevaid_V: string;
							statusCda_V?: string | null;
							statusCda_VId?: string | null;
							firstNameCda_V?: string | null;
							firstNameIntl_V?: string | null;
							middleNameCda_V?: string | null;
							middleNameIntl_V?: string | null;
							lastNameCda_V?: string | null;
							lastNameIntl_V?: string | null;
							nickname_V?: string | null;
							prefixCda_V?: string | null;
							suffixCda_V?: string | null;
							allDegreeCda_V?: string | null;
							degree1Cda_V?: string | null;
							hcpTypeCda_V?: string | null;
							hcpType?: {
								__typename?: 'HCPType';
								id: string;
								name: string;
								count: number;
							} | null;
							hcpSpecialties: Array<{
								__typename?: 'HCPSpecialty';
								primary: boolean;
								specialty: {
									__typename?: 'Specialty';
									id: string;
									name: string;
									specialtyGroup: {
										__typename?: 'SpecialtyGroup';
										id: string;
										name: string;
									};
								};
							}>;
							addresses: Array<{
								__typename?: 'Address';
								vid_V: string;
								primaryCda_V?: boolean | null;
								cityCda_V?: string | null;
								cityIntl_V?: string | null;
								stateCda_V?: string | null;
								countryCda_V?: string | null;
								streetAddress1Cda_V?: string | null;
								streetAddress1Intl_V?: string | null;
								postalCodeCda_V?: string | null;
								postalCodeIntl_V?: string | null;
							}>;
							affiliations: {
								__typename?: 'HCPAffiliationsResults';
								results: Array<{
									__typename?: 'ParentHCO';
									vid_V: string;
									isPrimaryRelationship_V?: boolean | null;
									parentHco:
										| {
												__typename?: 'HCO';
												vid_V: string;
												veevaid_V: string;
												statusCda_V?: string | null;
												statusCda_VId?: string | null;
												hcoNameCda_V?: string | null;
												hcoNameShort_V?: string | null;
												hcoNameEnglish_V?: string | null;
												hcoNameIntl_V?: string | null;
												hcoTypeCda_V?: string | null;
												addresses: Array<{
													__typename?: 'Address';
													vid_V: string;
													primaryCda_V?: boolean | null;
													cityCda_V?: string | null;
													cityIntl_V?: string | null;
													stateCda_V?: string | null;
													countryCda_V?: string | null;
													streetAddress1Cda_V?: string | null;
													streetAddress1Intl_V?: string | null;
													postalCodeCda_V?: string | null;
													postalCodeIntl_V?: string | null;
												}>;
												hcoType?: {
													__typename?: 'HCOType';
													id: string;
													name: string;
												} | null;
										  }
										| { __typename?: 'ResourceNotFound'; message: string };
								}>;
							};
					  }
					| { __typename?: 'ResourceNotFound' };
		  }
		| { __typename?: 'ResourceNotFound'; message: string };
};

export const UpdateRecentProfilesDocument = gql`
	mutation UpdateRecentProfiles($veevaId: ID!) {
		updateRecentProfiles(profileVisit: { veevaId: $veevaId }) {
			... on ProfileVisit {
				lastVisit
				profile {
					...HCPSummary
					...HCPAffiliationLink
					...HCOSummary
				}
			}
			...NotFoundError
		}
	}
	${HcpSummaryFragmentDoc}
	${HcpAffiliationLinkFragmentDoc}
	${HcoSummaryFragmentDoc}
	${NotFoundErrorFragmentDoc}
`;
export type UpdateRecentProfilesMutationFn = Apollo.MutationFunction<
	UpdateRecentProfilesMutation,
	UpdateRecentProfilesMutationVariables
>;

/**
 * __useUpdateRecentProfilesMutation__
 *
 * To run a mutation, you first call `useUpdateRecentProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecentProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecentProfilesMutation, { data, loading, error }] = useUpdateRecentProfilesMutation({
 *   variables: {
 *      veevaId: // value for 'veevaId'
 *   },
 * });
 */
export function useUpdateRecentProfilesMutation(
	baseOptions?: Apollo.MutationHookOptions<
		UpdateRecentProfilesMutation,
		UpdateRecentProfilesMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		UpdateRecentProfilesMutation,
		UpdateRecentProfilesMutationVariables
	>(UpdateRecentProfilesDocument, options);
}
export type UpdateRecentProfilesMutationHookResult = ReturnType<
	typeof useUpdateRecentProfilesMutation
>;
export type UpdateRecentProfilesMutationResult =
	Apollo.MutationResult<UpdateRecentProfilesMutation>;
export type UpdateRecentProfilesMutationOptions = Apollo.BaseMutationOptions<
	UpdateRecentProfilesMutation,
	UpdateRecentProfilesMutationVariables
>;
